import { render, staticRenderFns } from "./TvaParallax.vue?vue&type=template&id=270b798e&scoped=true&"
import script from "./TvaParallax.vue?vue&type=script&lang=js&"
export * from "./TvaParallax.vue?vue&type=script&lang=js&"
import style0 from "./TvaParallax.vue?vue&type=style&index=0&id=270b798e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b798e",
  null
  
)

component.options.__file = "TvaParallax.vue"
export default component.exports